import UgcReplaceImageControl from "./ReplaceImageControl";

export default UgcReplaceImageControl;
